import {bus} from '@/core/plugins/bus';
import {wait} from '@/core/helpers/wait';
import {ALERT} from '@/core/constants/modals';

export function useModalBus() {
    function createModal(data) {
        if (!data) {
            return;
        }

        bus.emit('modalShow', data);
    }

    function closeModal(data) {
        if (!data) {
            return;
        }

        bus.emit('modalClose', data);
    }

    async function createAlert(data) {
        if (!data) {
            return;
        }

        createModal({
            template: ALERT,
            ...data,
        });

        await wait(data.duration || 2000);

        closeModal(ALERT);
    }

    return {
        createModal,
        closeModal,
        createAlert,
    };
}
